import React, { useState, useEffect } from "react";
import { withRouter } from "../_shared/withRouter";
import { useTranslation } from "react-i18next";
import Header from "../template/_common/header";
import SidebarComponent from "../template/admin/sidebarComponent";
import AccessCodesTable from "../template/admin/accessCodesTable";
import SidebarArrow from "../template/_common/sidebarArrow";
import { globalAlert, globalLoader } from "../actions/commonActions";
import AddAccessCodeModal from "../template/admin/addAccessCodeModal";
import {
  addAccessCodeApi,
  getAccessCodeListApi,
  getDownloadAccessCodeListApi,
  toggleAccessCodeListApi,
  regenAccessCodeListApi,
  deleteAccessCodeApi,
  editAccessCodeApi,
} from "./_actions";
import PaginationOwn from "../template/_common/ownPagination";
import { compareValues, exportData, logOut } from "../_shared/commonFunction";
import ConfirmationModal from "../template/_common/confirmModal";
import { Helmet } from "react-helmet";
import InputComponent from "../template/_common/inputComponent";
import arraySort from 'array-sort';
import DatePicker from "react-date-picker";

const buildDateQuery = (fromDate, toDate) => {
  const params = new URLSearchParams();

  if (fromDate instanceof Date && !Number.isNaN(fromDate.getTime())) {
    params.set("fromDate", fromDate.toISOString());
  }
  if (toDate instanceof Date && !Number.isNaN(toDate.getTime())) {
    params.set("toDate", toDate.toISOString());
  }

  const query = params.toString();
  return query ? `?${query}` : "";
};


const AccessCodes = (props) => {
  const { t } = useTranslation();
  const [navbarToggle, setNavbarToggle] = useState(false);
  const [dataList, setDataList] = useState([]);
  const [currentData, setCurrentData] = useState(null);
  const [openAddAccessCodeModal, setOpenAddAccessCodeModal] = useState(false);
  const [editDataIs, setEditDataIs] = useState(false);
  const [confirmaModalOpen, setConfirmaModalOpen] = useState(false);
  const [confirmHeading, setConfirmHeading] = useState('');
  const [pageSize, setPageSize] = useState(25);
  const [searchVal, setSearchVal] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [currentDataList, setCurrentDataList] = useState([]);
  const [sortObj, setSortObj] = useState({});
  const [currentDataSorted, setCurrentDataSorted] = useState([]);
  const [notFilteredRun, setNotFilteredRun] = useState(false);
  const [totalCount, setTotalCount] = useState(false);
  const [allowView, setAllowView] = useState(true);
  const [confirmInfo, setConfirmInfo] = useState(null);
  const [currentId, setCurrentId] = useState("");
  const [confirmationType, setConfirmationType] = useState("");

  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [toMinDate, setToMinDate] = useState(null);
  const [fromMaxDate, setFromMaxDate] = useState(new Date());

  const setFromDateFunc = (val) => {
    setFromDate(val);
    setToMinDate(val);
  };

  const setToDateFunc = (val) => {
    setToDate(val);
    setFromMaxDate(val);
  };


  const handleSidebar = (data) => {
    setNavbarToggle(data);
  };

  useEffect(() => {
    callBasicApi(); // eslint-disable-next-line
  }, [fromDate, toDate]);

  const callBasicApi = async () => {
    try {
      globalLoader(true);
      const query = buildDateQuery(fromDate, toDate);
      let res = await getAccessCodeListApi(query);
      // let res;
      if (res?.data?.status === 200) {
        // setAllowView(true);
        // setDataList(res?.data?.data?.listAccessCodes);
        let currData = res?.data?.data?.listAccessCodes;
        setDataList(currData);

        setCurrentDataSorted(res?.data?.data?.storesList);
        setCurrentDataSorted(res?.data?.data?.listAccessCodes);
        !searchVal && setTotalCount(res?.data?.data?.listAccessCodes.length);
      } else {
        globalAlert("error", res?.data?.message);
      }
      globalLoader(false);
    } catch (error) {
      globalAlert("error", error?.response?.data?.message);

      if (error?.response?.data?.status === 401) {
        logOut(props?.history, "/admin/login");
      }
      globalLoader(false);
    }
  };

  const downloadFile = async () => {
    try {
      globalLoader(true);
      const query = buildDateQuery(fromDate, toDate);
      let res = await getDownloadAccessCodeListApi(query);
      if (res?.status === 200) {    
        if(!res.data){
          globalAlert("error", t("common.noDataFound"));
        }   
        else{
          exportData(res.data,  `AccessCode_${new Date().getTime()}.csv`, 'text/csv');
        }
      } else {
        globalAlert("error", res?.message);
      }
      globalLoader(false);
    }
    catch (error) {
      globalAlert(
        "error",
        error?.response?.data?.message || t("common.somethingWentWrong")
      );
      globalLoader(false);
    }
  };

  const closeAddAccessCodeModal = async (val = null) => {
    if (val) {
      globalLoader(true);
      let res;
      if (editDataIs) {
        res = await editAccessCodeApi(val, currentData?.accessCodeId);
      } else {
        res = await addAccessCodeApi(val);
      }

      if (res?.data?.status === 200) {
        globalAlert("success", res?.data?.message);
        if (editDataIs) {
          setEditDataIs(false);
        } else {
          setSearchVal("");
        }
        setNotFilteredRun(false);
        setCurrentData(null);
        setOpenAddAccessCodeModal(false);
        callBasicApi();
      } else {
        globalAlert("error", res?.data?.message);
        globalLoader(false);
      }
    } else {
      setEditDataIs(false);
      setCurrentData(null);
      setOpenAddAccessCodeModal(false);
    }
  };

  const editData = (data) => {
    setEditDataIs(true);
    setCurrentData(data);
    setOpenAddAccessCodeModal(true);
  };

  const toggleAccessCode = async (id) => {
    globalLoader(true);
    let res = await toggleAccessCodeListApi(id);
    if (res?.data?.status === 200) {
      setNotFilteredRun(false);
      callBasicApi();
    } else {
      globalAlert("error", res?.data?.message);
      globalLoader(false);
    }
  };

  const confirmModalFunc = async (val) => {

    try {
      if (val) {
        globalLoader(true);
        let res;

        if (confirmationType === 'generate') {
          res = await regenAccessCodeListApi(currentId)
        }
        else {
          res = await deleteAccessCodeApi(currentId);
        }

        if (res?.data?.status === 200) {
          if (totalCount === 1) {
            setSearchVal("");
          }
          setNotFilteredRun(false);
          callBasicApi();
        } else {
          globalAlert("error", res?.data?.message);
          globalLoader(false);
        }
      }
      setConfirmaModalOpen(false);
    }
    catch (err) {
      globalAlert("error", err?.response?.data?.message);
      globalLoader(false);
    }
  };
  const deleteData = (data) => {
    setCurrentId(data?.accessCodeId);
    let obj = [
      `Name : ${data?.docName}`,
      `Email : ${data?.docEmail}`,
      `Designation : ${data?.docDesignation}`,
    ];
    setConfirmInfo(obj);
    setConfirmHeading(t("admin.accessCodes.confirmDeleteCode"))
    setConfirmaModalOpen(true);
  };

  const regenAccessCode = async (data) => {

    setCurrentId(data?.accessCodeId);
    let obj = [
      `Name : ${data?.docName}`,
      `Email : ${data?.docEmail}`,
    ];
    setConfirmInfo(obj);
    setConfirmHeading(t("admin.accessCodes.confirmGenerateCode"))
    setConfirmaModalOpen(true);
    setConfirmationType('generate')

  };

  useEffect(() => {
    if (!notFilteredRun) {
      filteredDataFunc();
    } // eslint-disable-next-line
  }, [pageSize, currentPage, sortObj, currentDataSorted, dataList]);

  const filteredDataFunc = (dataArray = null, localPage = null) => {
    let arr = [...dataList];
    let filterArr = [];
    let filteredData = [];

    if (dataArray) {
      arr = [...dataArray]
    }
    else {
      arr = arraySort(arr, compareValues(sortObj?.sortVal), { reverse: sortObj?.sortType === 'desc' ? true : false });
    }
    if (searchVal.length > 0) {
      filterArr = arr.filter((data) => {
        if (
          data?.docName.toLowerCase().includes(searchVal.toLowerCase()) ||
          data?.docEmail.toLowerCase().includes(searchVal.toLowerCase()) ||
          data?.activeAccessCode?.accessCode
            .toLowerCase()
            .includes(searchVal.toLowerCase()) ||
          data?.docDesignation.toLowerCase().includes(searchVal.toLowerCase())
        ) {
          return data;
        } else {
          return null;
        }
      });
    } else {
      filterArr = arr;
    }
    if (filterArr && filterArr.length > 0) {
      setTotalCount(filterArr.length);
      for (
        let i = (localPage || currentPage) * pageSize - pageSize;
        i < (localPage || currentPage) * pageSize && i < filterArr.length;
        i++
      ) {
        filteredData.push(filterArr[i]);
      }
    }
    setCurrentDataList(filteredData);
  };

  const changePageSizeFunc = async (val) => {
    setNotFilteredRun(false);
    setPageSize(val.target.value);
    setCurrentPage(1);
    setSortObj(null);
  };

  const searchFilter = (ev) => {
    ev.preventDefault();
    let arr = [...dataList];
    let filterArr = arr.filter(
      (data) =>
        data?.docName.toLowerCase().includes(searchVal.toLowerCase()) ||
        data?.docEmail.toLowerCase().includes(searchVal.toLowerCase()) ||
        data?.activeAccessCode?.accessCode
          .toLowerCase()
          .includes(searchVal.toLowerCase()) ||
        data?.docDesignation.toLowerCase().includes(searchVal.toLowerCase())
    );
    setTotalCount(filterArr.length);
    setNotFilteredRun(true);
    setCurrentDataList(filterArr);
    setCurrentPage(1);
    setSortObj(null);
  };

  const goToPageFunc = (val, data) => {
    setNotFilteredRun(false);
    if (data === "prev" && currentPage > 1) {
      setCurrentPage(currentPage - 1);
    } else if (
      data === "next" &&
      currentPage < Math.ceil(dataList?.length / pageSize)
    ) {
      setCurrentPage(currentPage + 1);
    } else {
      setCurrentPage(val?.target?.value);
    }
  };

  const arraySorting = (val) => {
    let arr = [...dataList];
    let sortedArr;
    let sortType = "aesc";
    if (val === sortObj?.sortVal && sortObj?.sortType === "aesc") {
      sortType = "desc";
    }
    sortedArr = arraySort(arr, compareValues(val), { reverse: sortType === 'desc' ? true : false })
    setNotFilteredRun(true);
    setCurrentPage(1);
    setSortObj({
      sortVal: val,
      sortType: sortType,
    });
    filteredDataFunc(sortedArr, 1);
  };

  return (
    <>
      <Helmet>
        <title>{t("admin.pageTitle.accessCodes")} - eC-Card</title>
        <meta name="viewport" content="width=1200, initial-scale=1" />
      </Helmet>
      {allowView && (
        <div className="admin-portal">
          <Header roleType="admin" />
          <div className={`${navbarToggle ? "active" : ""} wrapper`}>
            <SidebarComponent
              navbarToggle={navbarToggle}
              active={props.match.path}
            />
            <div className="main">
              <div className="main-wrapper">
                <div>
                  <p className="admin-banner">{t("admin.accessCodes.title")}</p>
                </div>
                <SidebarArrow handleSidebarToggle={handleSidebar} />
                <div>
                  <div className="container-fluid">
                    <div className="row admin-controls">
                      <form
                        onSubmit={searchFilter}
                        className="col-12 col-lg-6 admin-search"
                      >
                        <div className="search-wrapper">
                          <InputComponent
                            placeholder="Search"
                            label={t("admin.accessCodes.searchPlaceholder")}
                            type="text"
                            name="search"
                            theme="admin"
                            value={searchVal}
                            handleCallback={(val) => {
                              setSearchVal(val);
                            }}
                          />
                        </div>
                        <button type="submit" className="btn secondary-btn">
                          {t("common.go")}
                        </button>
                      </form>
                      <div className="col-12 col-lg-6 admin-add-new mt-4 mt-lg-0 d-flex justify-content-start justify-content-lg-end">
                        <button
                          onClick={() => setOpenAddAccessCodeModal(true)}
                          className="btn secondary-btn modal-btn"
                        >
                          <i className="fas fa-plus"></i> {t("admin.accessCodes.addButton")}
                        </button>
                      </div>
                      {dataList?.length > 0 && (
                        <div
                          className="px-3 col-12 pt-3"
                          style={{ borderTop: "2px solid #ebeef1" }}
                        >
                          <PaginationOwn
                            pageSize={pageSize}
                            changePageSize={changePageSizeFunc}
                            goToPage={goToPageFunc}
                            totalCount={totalCount}
                            currentPage={currentPage}
                            applicationType={
                              currentDataList?.length > 1
                                ? "access-codes"
                                : "access-code"
                            }
                          />
                        </div>
                      )}
                      <div className="row col-12 form-report my-2">
                        <div className="form-report-group date-picker-class">
                          <label htmlFor="fromDate">{t("common.from")}</label>
                          <div className="datepicker-report">
                            <DatePicker
                              id="fromDate"
                              value={fromDate}
                              onChange={(ev) => setFromDateFunc(ev)}
                              maxDate={fromMaxDate}
                              format={"dd/MM/yyy"}
                            />
                          </div>
                        </div>
                        <div className="form-report-group date-picker-class">
                          <label htmlFor="toDate">{t("common.to")}</label>
                          <div className="datepicker-report">
                            <DatePicker
                              id="toDate"
                              value={toDate}
                              onChange={(ev) => setToDateFunc(ev)}
                              maxDate={new Date()}
                              format={"dd/MM/yyy"}
                              minDate={toMinDate}
                            />
                          </div>
                        </div>
                        {dataList?.length > 0 && (
                          <div className="form-report-group access-code-download">
                            <button
                              type="button"
                              onClick={downloadFile}
                              className="btn secondary-btn modal-btn"
                            >
                              <i className="fas fa-download"></i>{" "}
                              {t("common.download")}
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {currentDataList?.length > 0 ? (
                  <AccessCodesTable
                    dataList={currentDataList}
                    arraySorting={arraySorting}
                    basicApiCall={callBasicApi}
                    sortObj={sortObj}
                    regenData={regenAccessCode}
                    editData={editData}
                    toggleData={toggleAccessCode}
                    deleteData={deleteData}
                  />
                ) : (
                  <div className="px-3 pt-3">
                    <div className="no-data-available">{t("common.noDataAvailable")}</div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {openAddAccessCodeModal && (
        <AddAccessCodeModal
          open={openAddAccessCodeModal}
          closeModal={closeAddAccessCodeModal}
          data={currentData}
          edit={editDataIs}
        />
      )}
      {confirmaModalOpen && (
        <ConfirmationModal
          open={confirmaModalOpen}
          deleteInfo={confirmInfo}
          description={confirmHeading}
          onCloseModal={confirmModalFunc}
        />
      )}
    </>
  );
};

export default withRouter(AccessCodes);
